import { render, staticRenderFns } from "./jianyan-edit.vue?vue&type=template&id=d5e8f686&scoped=true&"
import script from "./jianyan-edit.vue?vue&type=script&lang=ts&"
export * from "./jianyan-edit.vue?vue&type=script&lang=ts&"
import style0 from "./jianyan-edit.vue?vue&type=style&index=0&id=d5e8f686&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5e8f686",
  null
  
)

export default component.exports